import styled from "styled-components";
import { fonts } from "../../styles/fonts";

const PageTitle = styled.h1`
  font-family: ${fonts.poppins};
  font-weight: 600;
  font-size: 2rem;
  margin-bottom: 20px;
`;

export default PageTitle;
